import { render, staticRenderFns } from "./CanvasPreview.vue?vue&type=template&id=a6908a5a&scoped=true&"
import script from "./CanvasPreview.vue?vue&type=script&lang=js&"
export * from "./CanvasPreview.vue?vue&type=script&lang=js&"
import style0 from "./CanvasPreview.vue?vue&type=style&index=0&id=a6908a5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6908a5a",
  null
  
)

export default component.exports